import { Component, inject, Input, OnInit } from '@angular/core';
import { ShowPerformance } from '../../models/showperformance.model';
import { PerformanceService } from '../../services/performance.service';
import { ModalController, NavController } from '@ionic/angular';
import { RehearsalDetailsModalComponent } from '../rehearsal/rehearsal-details-modal/rehearsal-details-modal.component';

@Component({
    selector: 'app-next-performance-card',
    templateUrl: './next-performance-card.component.html',
    styleUrls: ['./next-performance-card.component.scss'],
    standalone: false
})
export class NextPerformanceCardComponent implements OnInit {
    @Input() public shouldRefresh = false;
    public isLoading = true;
    public performance: ShowPerformance = null;
    private readonly navController: NavController = inject(NavController);
    private readonly modalController: ModalController = inject(ModalController);
    private performanceService: PerformanceService = inject(PerformanceService);

    constructor() {
    }

    public async ngOnInit(): Promise<void> {
        await this.loadNextPerformance();
    }

    public async loadNextPerformance(): Promise<void> {

        this.isLoading = true;
        try {
            this.performance = await this.performanceService.getNext();
        } catch (e) {
            console.error('[NextPerformanceCardComponent] loadNextPerformance() - error: ', e);
        } finally {
            this.isLoading = false;
        }
    }

    protected async navigateToPerformancesPage() {
        await this.navController.navigateRoot(['performances']);
    }

    protected hasRehearsal(): boolean {
        // Only true when the rehearsal has actual content (notes, purpose,
        // or requirements). An empty rehearsal exists from the moment the
        // resident director generates the external URL — surfacing the
        // button for that empty shell makes users tap it, see nothing,
        // and assume the app is broken.
        return this.performance?.rehearsalId != null && this.performance?.rehearsalHasContent === true;
    }

    /**
     * Open the rehearsal details modal for the next performance. Stops the
     * click event so it doesn't bubble to the card's own
     * `navigateToPerformancesPage` handler.
     */
    protected async openRehearsalModal(event: Event): Promise<void> {
        event.stopPropagation();
        if (!this.hasRehearsal()) { return; }
        const modal = await this.modalController.create({
            component: RehearsalDetailsModalComponent,
            componentProps: {
                rehearsalId: this.performance.rehearsalId
            },
            backdropDismiss: false
        });
        await modal.present();
    }

}
